/** delete word */
export const FORM_SERVER_API = 'http://lending-editor-server.frontend:8080'

/** parent category id */
export const MainCategoryId = process.env.NEXT_PUBLIC_WP_MAIN_CATEGORY_ID

export const EmailReg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/
export const IdMobileReg = /^(\()?(\+62|62|0)(\d{2,3})?\)?[ .-]?\d{2,4}[ .-]?\d{2,4}[ .-]?\d{2,4}/

export const FaqCategoryEn = [
  'Loan Status',
  'Loan Limit and tenor',
  'Why am I getting rejected',
  'How to apply for a loan',
  'How to cancel',
  'Repayment',
  'Error payment',
  'How to login',
  'Payment status',
]

export const FaqCategoryID = [
  'Status pinjaman',
  'Limit dan tenor pinjaman',
  'Mengapa pinjaman saya di tolak',
  'Cara mengajukan pinjaman',
  'Pembatalan pinjaman',
  'Pembayaran pinjaman',
  'Kesalahan pembayaran',
  'Cara login ke aplikasi',
  'Status pembayaran',
]

export enum MenuType {
  HOME = 'Home',
  PINTARSCORE = 'PintarScore',
  SHOP = 'PintarShop',
  PRODUCT = 'Product',
  FAQ = 'FAQ',
  ABOUT = 'AboutUs',
  EDU = 'Education',
  CAREER = 'Career',
  EVENT = 'EVENT',
  CONTACT = 'ContactUs',
  SUPPORT = 'Support',
}
/** -- education page ----- banner------ */
export const EDU_ANNER = 16965
/** -- FAQ page ----- RateList ------ */
export const RATE_LIST = 24804
/** -- FAQ page ----- CategoryList ------ */
export const FAQ_CATEGORY_LIST = 25004
/** -- home page ----- PromotionList ------ */
export const PROMOTION_LIST = 31630

/** -- FAQ page ----- Hot Posts ------ */
export const BLOG_FAQ_CATEGORY = 600281
export const pillarContent = [
  {
    key: 'Vision: ',
    value: 'Advance with intelligence for a better life',
  },
  {
    key: 'Mission: ',
    value: 'Make products, services and opportunities accessible and affordable to everyone and every business',
  },
  {
    key: 'Value: ',
    value: 'Customers Centric, Data Centric sm People Centric',
  },
  {
    key: 'Core Culture: ',
    value: 'Innovation, Collaboration, Integrity, Efficiency, Quality',
  },
]
/** FAQ-------- */
export const FAQ_OLD_QUESTIONS = [
  'mengapa-kredit-pintar-adalah-aplikasi-pinjaman-online-terbaik-untuk-saya',
  'bagaimana-cara-mengajukan-pinjaman-di-kredit-pintar',
  'apa-saja-syarat-untuk-dapat-mengajukan-pinjaman-uang-online',
  'bagaimana-membayar-tagihan-saya-dari-rumah',
  'pembayaran-melalui-bank',
  'cicilan-pembayaran',
  'keamanan-kerahasiaan-data',
  'customer-service-kredit-pintar',
]
export const CATEGORY_LIST = [
  {
    id: 597305,
    name: 'Berita Kredit Pintar',
    slug: 'berita-kredit-pintar',
    taxonomy: 'category',
    parent: 597302,
  },
  {
    id: 597326,
    name: 'Finansial Dan Bisnis',
    slug: 'finansial-bisnis',
    taxonomy: 'category',
    parent: 597302,
  },
  {
    id: 597325,
    name: 'Tips Pinjaman Online',
    slug: 'tips-pinjaman-online',
    taxonomy: 'category',
    parent: 597302,
  },
  {
    id: 600292,
    name: 'Promo',
    slug: 'promo',
    taxonomy: 'category',
    parent: 597302,
  },
  {
    id: 600716,
    name: 'Panduan Lengkap',
    slug: 'panduan-lengkap',
    taxonomy: 'category',
    parent: 597302,
  },
  {
    id: 600714,
    name: 'Tips Cari Cuan',
    slug: 'tips-cari-cuan',
    taxonomy: 'category',
    parent: 597302,
  },

  {
    id: 597327,
    name: 'Gaya Hidup',
    slug: 'gaya-hidup',
    taxonomy: 'category',
    parent: 597302,
  },
  {
    id: 597385,
    name: 'Kisah Sukses',
    slug: 'kisah-sukses',
    taxonomy: 'category',
    parent: 597302,
  },
  {
    id: 597462,
    name: 'Lainnya',
    slug: 'lainnya',
    taxonomy: 'category',
    parent: 597302,
  },
]
/** BlogTags, BlogHotTags */
export const TAG_GROUPS_ID = [1, 3]

/** -----calculator product */
export const CALCULATION_LIST = [
  { code: '2M_0.6MIL_24(165)', amount: 600000, tenor: 2, installment: '372,000' },
  { code: '2M_1.2MIL_24(166)', amount: 1200000, tenor: 2, installment: '744,000' },
  { code: '2M_1.8MIL_24(169)', amount: 1800000, tenor: 2, installment: '1,116,000' },
  { code: '3M_2.3MIL_36(172)', amount: 2300000, tenor: 3, installment: '1,042,700' },
  { code: '6M_6.0MIL_45 (177)', amount: 6000000, tenor: 6, installment: '1,450,000' },
  { code: '12M_10.0MIL_46 (182)', amount: 10000000, tenor: 12, installment: '1,216,700' },
  { code: '12M_20MIL_46 (209)', amount: 20000000, tenor: 12, installment: '2,443,400' },
  { code: '12M_50.0MIO_56_6.5 (687)', amount: 50000000, tenor: 12, installment: '6,229,167' },
]

/**--categoriesList */

export const CATEGORIES_LIST = [
  { id: 597243, name: 'Bisnis dan Keuangan' },
  { id: 600033, name: 'Info Loker' },
  { id: 600031, name: 'Tekno' },
  { id: 597242, name: 'Tips dan Gaya Hidup' },
]

export const MediaList = [
  {
    logo: '/images/home/media/kompas.png',
    url: 'https://money.kompas.com/read/2022/04/14/132647326/direktur-kredit-pintar-ungkap-pentingnya-inovasi-untuk-keberlangsungan?page=all',
  },
  {
    logo: '/images/home/media/detikcom.png',
    url: 'https://finance.detik.com/berita-ekonomi-bisnis/d-5935249/standard-chartered-suntik-kredit-pintar-rp-1-triliun',
  },
  {
    logo: '/images/home/media/TribunBisnis.png',
    url: 'https://www.tribunnews.com/bisnis/2022/06/03/gandeng-kredit-pintar-aplikasi-motionbanking-tambah-fitur-pinjaman-cepat',
  },
  {
    logo: '/images/home/media/Suara.png',
    url: 'https://www.suara.com/lifestyle/2022/04/23/150737/pinjaman-online-perlu-asuransi-lindungi-nasabah-dari-risiko-jiwa-dan-kese',
  },
  {
    logo: '/images/home/media/liputan6.png',
    url: 'https://www.liputan6.com/bisnis/read/4944063/konsumen-dapat-dua-manfaat-sekaligus-dari-kolaborasi-fwd-insurance-dan-kredit-pintar',
  },
  {
    logo: '/images/home/media/Kumparan.png',
    url: 'https://kumparan.com/kumparanbisnis/mau-tahu-rahasia-pintar-terhindar-dari-pinjaman-online-ilegal-1xO9zd1S9TF/3',
  },
  {
    logo: '/images/home/media/sindonews.png',
    url: 'https://ekbis.sindonews.com/read/789203/178/fitur-baru-motionbanking-kredit-pintar-pinjam-dana-cepat-dan-mudah-1654423588',
  },
  {
    logo: '/images/home/media/okefinance.png',
    url: 'https://economy.okezone.com/read/2022/06/05/622/2605990/fitur-baru-motionbanking-kredit-pintar-pinjam-dana-cepat-dan-mudah',
  },
  {
    logo: '/images/home/media/kontan.png',
    url: 'https://keuangan.kontan.co.id/news/fwd-dan-kredit-pintar-berkolaborasi-luncurkan-kredit-pintar-protection',
  },
  {
    logo: '/images/home/media/republika.png',
    url: 'https://www.republika.id/posts/24943/ekonomi-inklusif-melalui-teknologi',
  },
  {
    logo: '/images/home/media/investor.png',
    url: 'https://investor.id/finance/standard-chartered-dan-kredit-pintar-siapkan-pinjaman-digital-rp-1-triliun-nbsp',
  },
  {
    logo: '/images/home/media/business.png',
    url: 'https://www.businesstimes.com.sg/garage/standard-chartered-to-extend-us70-million-worth-of-loans-through-indonesias-kredit-pintar',
  },
  {
    logo: '/images/home/media/VIVAco.png',
    url: 'https://www.viva.co.id/digital/startup/1462372-memaksimalkan-media-sosial-untuk-menghasilkan-cuan',
  },
  {
    logo: '/images/home/media/duniafintech.png',
    url: 'https://duniafintech.com/kredit-pintar-telah-salurkan-pinjaman-rp-238-triliun-sejak-2017/',
  },
  {
    logo: '/images/home/media/medcom.png',
    url: 'https://www.medcom.id/ekonomi/keuangan/yNLL2p2N-kolaborasi-inovasi-digital-jawab-tantangan-proteksi-pinjaman-online',
  },
  {
    logo: '/images/home/media/jpnncom.webp',
    url: 'https://www.jpnn.com/news/hasilkan-cuan-lewat-media-sosial?utm_share_apps=5yLC1X8BC2lceao4kjLj',
  },
  {
    logo: '/images/home/media/RADAR-BANDUNG.png',
    url: 'https://www.radarbandung.id/2022/04/23/gandeng-komunitas-kredit-pintar-gelar-kelas-pintar-bersama-di-bandung/3/',
  },
  {
    logo: '/images/home/media/jabarekspres.png',
    url: 'https://jabarekspres.com/berita/2022/04/24/gandeng-komunitas-kredit-pintar-gelar-kelas-pintar-bersama-di-bandung-2/',
  },
  {
    logo: '/images/home/media/radarsurabaya.png',
    url: 'https://radarsurabaya.jawapos.com/ekonomi/21/05/2022/garap-market-surabaya-kredit-pintar-ajarkan-literasi-keuangan-ide-bisnis/',
  },
  {
    logo: '/images/home/media/antara.png',
    url: 'https://www.antaranews.com/berita/2917113/mnc-bank-dan-kredit-pintar-kolaborasi-beri-pinjaman-dana-tunai?utm_medium=mobile',
  },
  {
    logo: '/images/home/media/Shangbao.png',
    url: 'http://www.shangbaoindonesia.com/read/2022/06/03/financial-1654265316',
  },
]

// ai-bot constants
export const MAX_RECONNECT_ATTEMPTS = 5

export const PAGE_SIZE = 50

export const ITEM_SIZE = 300

export const FAKE_TYPING_ID = '-999'

export const FAKE_RECIEVE_ID = '-998'

export const RETRY_MESSAGE_PREFIX = 'retry_'

export const RECONNECT_INTERVAL = 5000

export const SCROLL_THRESHOLD = 64

export const BOTTOM_THRESHOLD = 200

export const HEARTBEAT_RATE = 10000

export const SEND_MESSAGE_TIMEOUT = 3 * HEARTBEAT_RATE

export const RECIEVE_MESSAGE_TIMEOUT = 31000

export const RETRY_BUTTON_TIMEOUT = 8 * 60 * 1000 // 8 minutes
